import {
  ChangeDetectorRef,
  ComponentRef,
  Directive,
  EmbeddedViewRef,
  Input,
  OnDestroy,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { LoaderComponent } from '@shared/components';

@Directive({
  selector: '[appLoader]',
})
export class LoaderDirective implements OnDestroy {
  private componentRef: ComponentRef<LoaderComponent> | null = null;
  private embeddedViewRef: EmbeddedViewRef<any> | null = null;

  constructor(
    private vcr: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  @Input() set appLoader(show: boolean | { show: boolean; text: string }) {
    if (typeof show === 'object') {
      if (show.show) {
        this.showLoader(show.text);
      } else {
        this.hideLoader();
      }
    } else {
      if (show) {
        this.showLoader();
      } else {
        this.hideLoader();
      }
    }
  }
  ngOnDestroy() {
    this.hideLoader();
  }

  private showLoader(text?: string) {
    if (!this.componentRef) {
      this.componentRef = this.vcr.createComponent(LoaderComponent);
      this.componentRef.instance.text = text || '';

      if (!this.embeddedViewRef) {
        this.embeddedViewRef = this.vcr.createEmbeddedView(this.templateRef);
      }
    }
  }

  private hideLoader() {
    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
      this.changeDetectorRef.detectChanges();
    }
  }
}
